import { AttachPhoto, AttachVideo } from '$store/models';
import { useSelector } from 'react-redux';
import { mainSelector } from '$store/main';
import { aesDecrypt } from '$utils';
import { useMemo, useState, useEffect } from 'react';
import axios from 'axios';

export function usePhotoUrl(photo: AttachPhoto, key: string, decryptKey: string = '') {
  if (photo[key]) {
    return photo[key];
  } else if (decryptKey) {
    return aesDecrypt(photo[key + 'Encrypted'], decryptKey);
  } else {
    return '';
  }
}

export function useVideoUrl(video: AttachVideo, customDecryptKey: string = '') {
  const { hasSubscription, mVerified, decryptKeyLegacy } = useSelector(mainSelector);

  return useMemo(() => {
    try {
      if (video.encrypted) {
        if (((hasSubscription || mVerified) && decryptKeyLegacy) || customDecryptKey) {
          const decrypted =
            aesDecrypt(video.source, customDecryptKey || decryptKeyLegacy) || '';
          const parsed = JSON.parse(decrypted);
          return parsed[0].path;
        } else {
          return '';
        }
      } else {
        const parsed = JSON.parse(video.source);
        return parsed[0].path;
      }
    } catch (e) {
      return '';
    }
  }, [video, decryptKeyLegacy, customDecryptKey, hasSubscription]);
}

export function useVideoPosterUrl(video: AttachVideo, customDecryptKey: string = '') {
  const { hasSubscription, mVerified, decryptKeyLegacy } = useSelector(mainSelector);

  return useMemo(() => {
    try {
      if (video.encrypted) {
        if (((hasSubscription || mVerified) && decryptKeyLegacy) || customDecryptKey) {
          return (
            aesDecrypt(video.photoMedium, customDecryptKey || decryptKeyLegacy) || ''
          );
        } else {
          return video.thumbnail;
        }
      } else {
        return video.photoMedium;
      }
    } catch (e) {
      return '';
    }
  }, [video, decryptKeyLegacy, customDecryptKey, hasSubscription]);
}
